<script lang="ts" setup>
import { computed } from 'vue'

import { TOOLTIP_OPEN_DELAY_MS } from '@/constants/practiceConstants'
import { allTransformations, type TransformationType } from '@/util/Transformations'

interface Props {
  modelValue: TransformationType
  includeTorahFont?: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  includeTorahFont: false,
})

const emit = defineEmits<{ (e: 'update:modelValue', value: TransformationType): void }>()

const transformations = computed(() => allTransformations(props.includeTorahFont))
</script>

<template>
  <v-btn-toggle
    color="primary"
    :disabled="disabled"
    mandatory
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-tooltip v-for="t in transformations" :key="t.name" bottom :open-delay="TOOLTIP_OPEN_DELAY_MS" :text="t.subtitle">
      <template #activator="{ props: tipProps }">
        <v-btn v-bind="tipProps" class="text-h6" :class="t.props.class" :value="t">{{ t.title }}</v-btn>
      </template>
    </v-tooltip>
  </v-btn-toggle>
</template>
